import * as React from "react";

export default () => {
  return <div>Grundläggande information kring lokalen</div>;
};
